import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { useSelectedPoolsStore } from '../../../../context/selected-pools.store';
import { StakeholderPoolsPlansTableColumnTitle } from '../../../../types/pool-plans.types';
import { PlanStakeholder, Stakeholder } from '../../../../types/stakeholder.types';
import { ScrollableStakeholderItem, StickyStakeholderItem } from './stakeholder-item';

type StickyStakeholderTableProps = {
  date: Date;
  poolsByStakeholders: Stakeholder[] | undefined;
};

export const StickyStakeholderTable: FC<StickyStakeholderTableProps> = ({
  poolsByStakeholders,
  date,
}) => {
  const { stakeholderState } = useSelectedPoolsStore();

  return (
    <table className="h-fit transition-all">
      <thead>
        <tr className="flex border-y-[1px] border-[#F2F2F2] bg-gray-50">
          <td className="relative">
            <div className="flex h-full w-[48px] items-center justify-center"> </div>
          </td>
          <td className="px-4 py-3">
            <div className="flex items-center">
              <span className="min-w-[210px] max-w-[320px] text-label-md font-[450] text-[#172335]">
                <AppFormattedMessage id="STAKEHOLDER" />
              </span>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        {poolsByStakeholders && (
          <>
            {poolsByStakeholders.map((stakeholder) => (
              <StickyStakeholderItem
                date={date}
                isSelected={stakeholderState.stakeholderId.includes(stakeholder.id)}
                key={stakeholder.id}
                stakeholder={stakeholder}
              />
            ))}
          </>
        )}
      </tbody>
    </table>
  );
};

export type ScrollableStakeholderTableProps = {
  date: Date;
  onDeleteClick: (id: string) => void;
  onDeletePlanClick: (id: string) => void;
  onEditClick: (id: string) => void;
  onEditPlanClick: (id: string) => void;
  onEditTerminationDateClick: (id: string) => void;
  onViewClick: (id: string) => void;
  onViewPlanClick: (id: string) => void;
  poolsByStakeholders: PlanStakeholder[] | undefined;
};

const tableColumns = Object.values(StakeholderPoolsPlansTableColumnTitle);

export const ScrollableStakeholderTable: FC<ScrollableStakeholderTableProps> = ({
  poolsByStakeholders,
  onEditClick,
  onViewClick,
  onDeleteClick,
  onEditPlanClick,
  onViewPlanClick,
  onDeletePlanClick,
  onEditTerminationDateClick,
  date,
}) => {
  const { stakeholderState } = useSelectedPoolsStore();
  return (
    <table className="w-full transition-all">
      <thead>
        <tr className="border-y-[1px] border-[#F2F2F2] bg-gray-50">
          {tableColumns.map((column) => (
            <td className="px-4 py-3" key={column}>
              <div className="flex items-center">
                <span className="whitespace-nowrap text-label-md font-[450] text-[#172335]">
                  <AppFormattedMessage id={column} />
                </span>
              </div>
            </td>
          ))}
          <td className="relative">
            <div className="flex h-full w-full items-center justify-center px-6"></div>
          </td>
        </tr>
      </thead>
      <tbody>
        {poolsByStakeholders && (
          <>
            {poolsByStakeholders.map((stakeholder) => (
              <ScrollableStakeholderItem
                date={date}
                isSelected={stakeholderState.stakeholderId.includes(stakeholder.id)}
                key={stakeholder.id}
                onDeleteClick={onDeleteClick}
                onDeletePlanClick={onDeletePlanClick}
                onEditClick={onEditClick}
                onEditPlanClick={onEditPlanClick}
                onEditTerminationDateClick={onEditTerminationDateClick}
                onViewClick={onViewClick}
                onViewPlanClick={onViewPlanClick}
                stakeholder={stakeholder}
              />
            ))}
          </>
        )}
      </tbody>
    </table>
  );
};
